// Shared playback for section videos; the process section also supplies a replay button.
if (!customElements.get('deferred-video')) customElements.define('deferred-video', class extends HTMLElement {
  connectedCallback() {
    this.frame = requestAnimationFrame(() => this.initialize());
  }

  initialize() {
    if (!this.isConnected || this.video) return;
    const video = this.querySelector('video');
    if (!video) return;
    this.video = video;
    this.inView = false;
    video.muted = true;
    video.playsInline = true;
    this.load = () => {
      const sources = video.querySelectorAll('source[data-src]');
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      for (const source of sources) {
        source.src = (desktop && source.dataset.desktopSrc) || source.dataset.src;
        delete source.dataset.src;
      }
      if (sources.length && desktop && video.dataset.desktopPoster) video.poster = video.dataset.desktopPoster;
      // Choose once, when the section approaches the viewport. A later resize
      // must not restart playback or download the other version as well.
      if (sources.length) video.load();
    };
    this.play = () => {
      this.load();
      // Mobile browsers may refuse autoplay. Keep a usable manual play control.
      video.play().catch(error => {
        if (this.isConnected && error.name !== 'AbortError') video.controls = true;
      });
    };
    this.updatePlayback = () => {
      if (this.inView && !document.hidden) this.play();
      else video.pause();
    };
    this.replayButton = this.querySelector('.process-replay');
    this.replay = () => {
      video.currentTime = 0;
      this.play(); // Call directly in the tap handler to retain the user gesture.
    };
    this.replayButton?.addEventListener('click', this.replay);
    document.addEventListener('visibilitychange', this.updatePlayback);
    if (!('IntersectionObserver' in window)) {
      this.load();
      video.controls = true;
      return;
    }
    // Fetch metadata shortly before reaching the section, then play when visible.
    this.loadObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        video.preload = 'metadata';
        this.load();
        this.loadObserver.disconnect();
      }
    }, {rootMargin: '250px'});
    this.loadObserver.observe(video);
    this.observer = new IntersectionObserver(([entry]) => {
      this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
      this.updatePlayback();
    }, {threshold: [0, 0.25]});
    this.observer.observe(video);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect();
    this.loadObserver?.disconnect();
    this.video?.pause();
    this.replayButton?.removeEventListener('click', this.replay);
    if (this.updatePlayback) document.removeEventListener('visibilitychange', this.updatePlayback);
    this.video = null;
  }
});
